import React, { useMemo } from 'react';
import { Icon, Modal } from '@testsigma/atoms';
import classNames from 'classnames';
import { getNextZIndex } from '@utils/model-utils';

interface DeleteModalProps {
  show: boolean;
  onHideModal: () => void;
  children: React.ReactNode;
  contentDirection?: 'row' | 'col';
  className?: string;
  closeOnOutsideClick?: boolean;
  showCloseIcon?: boolean;
  iconClassName?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  show,
  onHideModal,
  children,
  contentDirection = 'row',
  className,
  closeOnOutsideClick = true,
  showCloseIcon,
  iconClassName,
}) => {
  const directionClass = useMemo(() => {
    return contentDirection === 'row' ? 'flex-row' : 'flex-col';
  }, [contentDirection]);

  return (
    <Modal
      isOpen={show}
      className={classNames('!rounded-xl !p-6 !w-125', className)}
      closeOnEscape={true}
      closeOnOutsideClick={closeOnOutsideClick}
      onClose={onHideModal}
      zIndex={getNextZIndex()}
    >
      <div className={classNames('flex gap-x-6', directionClass)}>
        <div className='flex items-start justify-between'>
          <div className=' h-12 w-12 rounded-full border-spacing-2.5 bg-error-50 flex items-center justify-center'>
            <Icon
              name='error'
              className='flex text-2xl text-error-600 p-1 bg-error-100 rounded-full'
            ></Icon>
          </div>
          {showCloseIcon && (
            <Icon
              name='close'
              className={classNames(
                'text-lg text-secondary-500 cursor-pointer ',
                iconClassName,
              )}
              onClick={onHideModal}
            ></Icon>
          )}
        </div>
        <div className='flex-1'>{children}</div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
